import request from '@/services/request'

export function getMasterRecipeList () {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-recipe/common-list',
    method: 'get'
  })
}

export function fetchAll (data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-recipe/list',
    method: 'get',
    params: data
  })
}

export function changeStatusItem (data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-recipe/update-status',
    method: 'put',
    data: data
  })
}

export function get (data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-recipe/detail',
    method: 'get',
    params: data
  })
}

export function create (data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-recipe/create',
    method: 'post',
    data: data
  })
}

export function update (data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-recipe/update',
    method: 'put',
    data: data
  })
}







// WEBPACK FOOTER //
// ./src/api/master_recipe.js